import { render, staticRenderFns } from "./CoverPage.vue?vue&type=template&id=d6f40ef2"
import script from "./CoverPage.vue?vue&type=script&lang=js"
export * from "./CoverPage.vue?vue&type=script&lang=js"
import style0 from "./CoverPage.vue?vue&type=style&index=0&id=d6f40ef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports